
import { defineComponent, PropType, computed } from 'vue';
import { IBienBanGiaiTheResponseBase } from '@/core/interfaces/ApiResponses';
import { useBienBanComplete } from '@/core/hooks/use-bien-ban-complete';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import ConfirmHoanThanh from '@/components/shared/confirm-hoan-thanh-modal/ConfirmHoanThanh.vue';
import PageHeaderActionItem from '@/layout/header/PageHeaderActionItem.vue';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';

export default defineComponent({
  name: 'BienBanCompleteButton',

  components: {
    ButtonCustom,
    ConfirmHoanThanh,
    PageHeaderActionItem,
  },

  props: {
    bienBan: {
      type: Object as PropType<IBienBanGiaiTheResponseBase | null>,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
    showButtonLabel: {
      type: Boolean,
      default: false,
    },
    asMenuItem: {
      type: Boolean,
      default: false,
    },
    onSuccess: {
      type: Function as PropType<() => void | Promise<void>>,
      default: undefined,
    },
  },

  setup(props) {
    const { ButtonTypeColors, ButtonsType } = useButtonCustom();

    const {
      showCompleteDialog,
      openCompleteDialog: openDialog,
      closeCompleteDialog,
      handleComplete: handleCompleteAction,
    } = useBienBanComplete(props.onSuccess);

    const openCompleteDialog = () => {
      if (props.bienBan) {
        openDialog(props.bienBan);
      }
    };

    const handleComplete = async (data: { date: Date }) => {
      await handleCompleteAction(data);
    };

    const computedTooltipMessage = computed(() => {
      if (props.tooltipMessage) {
        return props.tooltipMessage;
      }

      if (!props.bienBan) {
        return '';
      }

      if (props.bienBan.ngay_ra_xuong) {
        return 'Đã hoàn thành';
      }

      return 'Hoàn thành BBGT';
    });

    const computedIsDisabled = computed(() => {
      if (props.isDisabled) {
        return true;
      }

      if (!props.bienBan) {
        return true;
      }

      // Disable if already completed
      if (props.bienBan.ngay_ra_xuong) {
        return true;
      }

      // Disable if not both approved and admin approved
      if (!props.bienBan.is_admin_approved || !props.bienBan.is_approved) {
        return true;
      }

      return false;
    });

    return {
      ButtonTypeColors,
      ButtonsType,
      showCompleteDialog,
      openCompleteDialog,
      closeCompleteDialog,
      handleComplete,
      computedTooltipMessage,
      computedIsDisabled,
      faCalendarCheck,
    };
  },
});
